import React from 'react';
import styled, { css } from 'styled-components';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const MESSAGES = {
  login: 'Cashback desativado. Entre para ativar.',
  pix: 'Cadastre sua chave Pix para receber o cashback.',
};

const COLORS = {
  background: '#FFF4E5',
  border: '#F5A623',
  text: '#663C00',
};

const Notice = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid ${COLORS.border};
  background-color: ${COLORS.background};
  color: ${COLORS.text};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  ${({ $placement }) =>
    $placement === 'below'
      ? css`
          /* Sobreposto ao conteúdo para não mudar a altura do menu */
          position: absolute;
          top: calc(100% + 6px);
          right: 0;
          z-index: 20;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);

          /* Setinha apontando para o botão */
          &::before {
            content: '';
            position: absolute;
            top: -5px;
            right: 18px;
            width: 8px;
            height: 8px;
            background-color: ${COLORS.background};
            border-left: 1px solid ${COLORS.border};
            border-top: 1px solid ${COLORS.border};
            transform: rotate(45deg);
          }
        `
      : css`
          margin-top: 8px;
          white-space: normal;
          text-align: center;
          justify-content: center;
          border-radius: 12px;
        `}
`;

// Aviso de cashback ao lado do botão de login/perfil do menu
const CashbackNotice = ({ type, placement = 'below', onClick }) => {
  if (!type) return null;

  const clickable = !!onClick;

  return (
    <Notice
      $placement={placement}
      $clickable={clickable}
      role={clickable ? 'button' : 'status'}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={clickable ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      <WarningAmberRoundedIcon sx={{ fontSize: 14, color: COLORS.border }} />
      {MESSAGES[type]}
    </Notice>
  );
};

export default CashbackNotice;
